module.exports = __webpack_public_path__ + "static/media/RoomService_Meal1_Categories_Cat1_Quantity1.a418862f.png";